import { useRef, useState } from "react";
import { toast } from "sonner";
import { Loader2, Sparkles, Upload } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const MODES = [
  { key: "ai", label: "Yapay zeka ile HD" },
  { key: "sharpen", label: "Basit keskinleştirme" },
  { key: "none", label: "Olduğu gibi" },
];

export function ImageUploader({ onUploaded, testid = "image-uploader", compact = false }) {
  const [mode, setMode] = useState("ai");
  const [busy, setBusy] = useState(false);
  const ref = useRef();

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    fd.append("mode", mode);
    try {
      const { data } = await api.post("/admin/images", fd);
      toast.success(data.note || "Görsel yüklendi");
      onUploaded(data.url);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
      ref.current.value = "";
    }
  };

  return (
    <div className={`flex ${compact ? "flex-col" : "flex-wrap items-center"} gap-2`}>
      <select data-testid={`${testid}-mode`} value={mode} onChange={(e) => setMode(e.target.value)} className="h-9 border rounded-md px-2 text-sm bg-white">
        {MODES.map((m) => <option key={m.key} value={m.key}>{m.label}</option>)}
      </select>
      <input ref={ref} type="file" accept="image/*" hidden onChange={(e) => upload(e.target.files[0])} data-testid={`${testid}-input`} />
      <button type="button" data-testid={`${testid}-button`} disabled={busy} onClick={() => ref.current.click()}
        className="h-9 px-3 rounded-md bg-[#172554] text-white text-sm font-semibold flex items-center gap-2 disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : mode === "ai" ? <Sparkles className="h-4 w-4" /> : <Upload className="h-4 w-4" />}
        {busy ? (mode === "ai" ? "HD yapılıyor..." : "Yükleniyor...") : "Resim Yükle"}
      </button>
    </div>
  );
}
